(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ask-mike-project-gallery"]) return;
  try {
    
function initAskMikeGallery(){const panel=document.getElementById('ask-mike-projects');if(!panel||panel.dataset.galleryReady)return;panel.dataset.galleryReady='true';const cards=[...panel.querySelectorAll('[data-am-category]')];const filters=[...panel.querySelectorAll('[data-am-filter]')];filters.forEach(button=>button.addEventListener('click',()=>{filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));cards.forEach(card=>card.hidden=button.dataset.amFilter!=='all'&&card.dataset.amCategory!==button.dataset.amFilter);}));const dialog=panel.querySelector('dialog');let opener;panel.querySelectorAll('.am-photo-open').forEach(button=>button.addEventListener('click',()=>{opener=button;const img=dialog.querySelector('img');img.src=button.dataset.amFull;img.alt=button.dataset.amCaption;dialog.querySelector('figcaption').textContent=button.dataset.amCaption;dialog.showModal();}));dialog.querySelector('.am-photo-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});dialog.addEventListener('close',()=>{if(opener)opener.focus();});window.addEventListener('hashchange',()=>{if(dialog.open)dialog.close();});}initAskMikeGallery();document.addEventListener('shopify:section:load',initAskMikeGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ask-mike-services"] && !Shopify.designMode) return;
  try {
    
function initAskMikeNavigation(){
const root=document.querySelector('.am-service');if(!root||root.dataset.navigationReady)return;root.dataset.navigationReady='true';
const home=root.querySelector('.am-home');const panels=[...root.querySelectorAll('.am-panel')];const main=root.closest('main');const section=root.closest('.shopify-section');
const siblings=main?[...main.children].filter(el=>el!==section&&!el.contains(root)):[];
function navigate(scroll){let id=location.hash.slice(1);const serviceRoutes={"ask-mike-estimates":"/pages/contractor-estimate-review","ask-mike-bids":"/pages/contractor-bid-comparison","ask-mike-planning":"/pages/home-project-consultation","ask-mike-lessons":"/pages/virtual-diy-lessons","ask-mike-trade":"/pages/carpentry-lessons","ask-mike-advisor":"/pages/construction-project-advisor","ask-mike-experience":"/pages/about-mike","ask-mike-local":"/pages/local-home-project-consultation","ask-mike-proposals":"/pages/contractor-estimate-review#ask-mike-proposals","ask-mike-planning-details":"/pages/home-project-consultation#ask-mike-planning-details","ask-mike-consultation":"/pages/home-project-consultation#ask-mike-consultation","ask-mike-projects":"/pages/construction-project-examples"};if(serviceRoutes[id]){const destination=serviceRoutes[id];const route=new URL(destination,location.origin);const preview=new URLSearchParams(location.search).get('preview_theme_id')||(root.dataset.amThemeRole==='unpublished'?root.dataset.amThemeId:null);if(preview){route.pathname='/pages/contact';route.search='?view=seo-preview-'+destination.split('/').pop().split('#')[0]+'&preview_theme_id='+preview;}location.replace(route.href);return;}if(id==='AskMikeIntake')id='ask-mike-intake';const formRoutes={AskMikeAgreements:'ask-mike-forms',AskMikeRentalAgreement:'ask-mike-rental-agreement',AskMikeToolSignoff:'ask-mike-tool-signoff',AskMikeEquipmentReturn:'ask-mike-equipment-return',AskMikeLessonAgreement:'ask-mike-lesson-agreement'};if(formRoutes[id])id=formRoutes[id];if(!id&&root.querySelector('.success,.errors'))id='ask-mike-intake';if(id==='ask-mike-services')id='ask-mike-advice';let target=document.getElementById(id);if(target&&target.tagName==='DETAILS')target.open=true;let selected=target&&root.contains(target)?target.closest('.am-panel'):null;
home.hidden=Boolean(selected);panels.forEach(p=>p.hidden=p!==selected);siblings.forEach(el=>{if(selected){if(!el.hasAttribute('data-am-was-hidden'))el.dataset.amWasHidden=String(el.hidden);el.hidden=true;}else if(el.hasAttribute('data-am-was-hidden')){el.hidden=el.dataset.amWasHidden==='true';delete el.dataset.amWasHidden;}});
if(scroll&&id.startsWith('ask-mike'))requestAnimationFrame(()=>{const dest=selected?(target||selected):root;dest.scrollIntoView({block:'start'});if(selected)selected.focus({preventScroll:true});});}
window.addEventListener('hashchange',()=>navigate(true));
document.addEventListener('click',event=>{const a=event.target.closest('a[href]');if(!a)return;const url=new URL(a.href,location.href);if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash.startsWith('#ask-mike'))return;if(location.pathname!=='/')return;event.preventDefault();const select=root.querySelector('#am-service');if(select&&a.dataset.amService){const aliases={complex:'review',detailed:'review',proposal:'review',epoxy:'furniture',lesson_local:'local_consultation'};select.value=aliases[a.dataset.amService]||a.dataset.amService;if(a.dataset.amService.startsWith('lesson_')&&a.dataset.amService!=='lesson_local')root.querySelector('#am-preference').value='video';if(a.dataset.amService==='local_consultation'||a.dataset.amService==='lesson_local')root.querySelector('#am-preference').value='local';}if(location.hash===url.hash)navigate(true);else location.hash=url.hash;document.querySelectorAll('header details[open]').forEach(d=>{d.open=false;const summary=d.querySelector('summary');if(summary)summary.setAttribute('aria-expanded','false');});document.body.classList.remove('overflow-hidden-mobile','overflow-hidden-tablet');});
navigate(Boolean(location.hash));}
initAskMikeNavigation();document.addEventListener('shopify:section:load',initAskMikeNavigation);


function initAskMikeAgreements(){
['AskMikeRentalAgreement','AskMikeToolSignoff','AskMikeEquipmentReturn','AskMikeLessonAgreement'].forEach(id=>{
const form=document.getElementById(id);if(!form||form.dataset.amReady||!form.querySelector('[name="contact[record_type]"]'))return;form.dataset.amReady='true';
form.querySelector('button[type="submit"]').disabled=false;
form.addEventListener('submit',()=>{
const label=form.closest('.am-panel').querySelector('h2').textContent.trim();
const details=[...form.querySelectorAll('input,textarea,select')].filter(el=>el.name.startsWith('contact[')&&!['contact[body]','contact[browser_submission_time]'].includes(el.name)).map(el=>el.name+': '+(el.type==='checkbox'?(el.checked?'Acknowledged':'Not acknowledged'):el.value));
const terms=[...form.querySelectorAll('[data-am-agreement-text]')].map(el=>el.textContent.trim()).join('\n\n');
form.querySelector('[name="contact[body]"]').value='Ask Mike signed record: '+label+'\n\n'+details.join('\n')+'\n\nACCEPTED TERMS\n'+terms+'\n\nCompany verification remains pending.';
form.querySelector('[name="contact[browser_submission_time]"]').value=new Date().toISOString();
});});}
initAskMikeAgreements();document.addEventListener('shopify:section:load',initAskMikeAgreements);

function initAskMikeGallery(){const panel=document.getElementById('ask-mike-projects');if(!panel||panel.dataset.galleryReady)return;panel.dataset.galleryReady='true';const cards=[...panel.querySelectorAll('[data-am-category]')];const filters=[...panel.querySelectorAll('[data-am-filter]')];filters.forEach(button=>button.addEventListener('click',()=>{filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));cards.forEach(card=>card.hidden=button.dataset.amFilter!=='all'&&card.dataset.amCategory!==button.dataset.amFilter);}));const dialog=panel.querySelector('dialog');let opener;panel.querySelectorAll('.am-photo-open').forEach(button=>button.addEventListener('click',()=>{opener=button;const img=dialog.querySelector('img');img.src=button.dataset.amFull;img.alt=button.dataset.amCaption;dialog.querySelector('figcaption').textContent=button.dataset.amCaption;dialog.showModal();}));dialog.querySelector('.am-photo-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});dialog.addEventListener('close',()=>{if(opener)opener.focus();});window.addEventListener('hashchange',()=>{if(dialog.open)dialog.close();});}initAskMikeGallery();document.addEventListener('shopify:section:load',initAskMikeGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
